import { PDFViewer } from './PDFViewer';
import { DOCXViewer } from './DOCXViewer';
import { CSVViewer } from './CSVViewer';
import { TXTViewer } from './TXTViewer';
import { XLSXViewer } from './XLSXViewer';

type FileViewerProps = {
  fileUrl: string;
  contentType: string;
};

export function FileViewer({ fileUrl, contentType }: FileViewerProps) {
  console.log('FileViewer - fileUrl:', fileUrl);
  console.log('FileViewer - contentType:', contentType);

  const getViewer = () => {
    if (!contentType) {
      console.log('No contentType provided');
      return (
        <div className="flex items-center justify-center h-full text-gray-500">
          <p>Unable to preview file: content type not specified</p>
        </div>
      );
    }

    if (contentType.includes('pdf')) {
      console.log('Rendering PDFViewer');
      return <PDFViewer fileUrl={fileUrl} />;
    }

    if (
      contentType.includes('word') ||
      contentType.includes('officedocument.wordprocessingml')
    ) {
      console.log('Rendering DOCXViewer');
      return <DOCXViewer fileUrl={fileUrl} />;
    }

    if (contentType.includes('csv')) {
      console.log('Rendering CSVViewer');
      return <CSVViewer fileUrl={fileUrl} />;
    }

    if (contentType.includes('text/plain')) {
      console.log('Rendering TXTViewer');
      return <TXTViewer fileUrl={fileUrl} />;
    }

    if (contentType.includes('spreadsheet') || contentType.includes('excel')) {
      console.log('Rendering XLSXViewer');
      return <XLSXViewer fileUrl={fileUrl} />;
    }

    console.log('No viewer found for contentType:', contentType);
    return (
      <div className="flex items-center justify-center h-full text-gray-500">
        <p>Preview not available for this file type: {contentType}</p>
      </div>
    );
  };

  return <div className="h-full w-full">{getViewer()}</div>;
}
